import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { productsDefault } from 'Components/User/Orders/Products'
import { apiOrdersList, apiOrdersView } from 'Services/UserService'

export const getData = createAsyncThunk('user/orders/getData', async datas => {
    const { data } = await apiOrdersList(datas)
    return data
})

export const getView = createAsyncThunk('user/orders/getView', async id => {
    if (!id) return viewData
    const { data } = await apiOrdersView(id)
    data.products = data.products && data.products.length !== 0 ? data.products : [productsDefault]
    return data
})

const viewData = {
    customer_id: '',
    referral_id: '',
    challan_number: '',
    site_name: '',
    order_type: '',
    payment_terms: '',
    details: '',
    sub_total: '',
    gst: 9,
    cgst_amount: '',
    sgst_amount: '',
    discount: 0,
    total: '',
    products: [productsDefault],
}

export const ordersSlice = createSlice({
    name: 'user/orders',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: 'created_at',
            dir: 'desc',
            store_id: '',
            customer_id: '',
            referral_id: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setStoreId: (state, { payload }) => {
            state.table.page = 1
            state.table.store_id = payload
            state.table.customer_id = ''
            state.table.referral_id = ''
        },
        setCustomerId: (state, { payload }) => {
            state.table.page = 1
            state.table.customer_id = payload
        },
        setReferralId: (state, { payload }) => {
            state.table.page = 1
            state.table.referral_id = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setStoreId, setCustomerId, setReferralId } = ordersSlice.actions

export default ordersSlice.reducer
